import sass from "./history.module.sass";

export const badge = {
	"/audit/organization": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Создание
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление
				</div>
			),
		},

		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Перемещение в архив
				</div>
			),
		},
		CATEGORIZATION_STATUS: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование статуса категорирования;
				</div>
			),
		},
		MARKERS: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование маркеров организации
				</div>
			),
		},
		ACTIVITY_AREAS: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование видов деятельности организации
				</div>
			),
		},
		LOGO: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование логотипа
				</div>
			),
		},
		SUBSIDIARY: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление дочерней организации
				</div>
			),
		},
		SUBSIDIARY_CATEGORIZATION_SETUP: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование настройки категорирования дочерней организации
				</div>
			),
		},
		OKVED: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование кодов ОКВЭД
				</div>
			),
		},
	},
	"/audit/employee": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Перемещение в архив
				</div>
			),
		},
		BIND: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление связи с пользователем
				</div>
			),
		},
		UNBIND: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление связи с пользователем
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
	},
	"/audit/user": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Создание
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Перемещение в архив
				</div>
			),
		},
		BIND: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление связи с сотрудником
				</div>
			),
		},
		UNBIND: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление связи с сотрудником
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
	},
	"/audit/role": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Создание роли
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование роли
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление роли
				</div>
			),
		},
		ASSIGN: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Назначение роли
				</div>
			),
		},
		UNASSIGN: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Отмена назначения роли
				</div>
			),
		},
	},
	"/audit/dictionary/okved": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
		IMPORT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Импорт файла
				</div>
			),
		},
	},
	"/audit/dictionary/activity-area": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/ownership-type": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/organization-document-pattern": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Обновление шаблона
				</div>
			),
		},
		USER_EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование пользовательского шаблона
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Сброс до системного шаблона
				</div>
			),
		},
		IMPORT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Импорт
				</div>
			),
		},
	},
	"/audit/dictionary/person-status": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/construction-object": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/organization-marker": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/object-status": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/object-type": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/inapplicability-reason": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/significance-criteria": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Aрхивация
				</div>
			),
		},
		RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление документа из архива
				</div>
			),
		},
	},

	"/audit/dictionary/business-process-pattern": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
							fill="#FFA51F"
						/>
					</svg>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
							fill="#F2485C"
						/>
					</svg>
					Удаление
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
							fill="#F2485C"
						/>
					</svg>
					Архивация
				</div>
			),
		},
		RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление
				</div>
			),
		},
	},
	"/audit/dictionary/threat-model-template": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
							fill="#FFA51F"
						/>
					</svg>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
							fill="#F2485C"
						/>
					</svg>
					Удаление
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
							fill="#F2485C"
						/>
					</svg>
					Архивация
				</div>
			),
		},
		RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление
				</div>
			),
		},
	},

	"/audit/dictionary/threat-consequence": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
						<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
					</svg>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/dictionary/threat": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/document": {
		UPLOAD: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Загрузка
				</div>
			),
		},
		VERSION: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Обновление версии
				</div>
			),
		},
		ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Перенос в архив
				</div>
			),
		},
		FOLDER: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Создание папки
				</div>
			),
		},
		FOLDER_ARCHIVE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Перенос папки в архив
				</div>
			),
		},
		RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление документа из архива
				</div>
			),
		},
		FOLDER_RESTORE: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Восстановление папки из архива
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование документа
				</div>
			),
		},
		FOLDER_EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование папки
				</div>
			),
		},
	},
	"/audit/categorization/1": {
		CREATE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Создание комиссии
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Изменение состава комиссии
				</div>
			),
		},
		DOCUMENT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Загрузка утвержденного приказа
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление комиссии
				</div>
			),
		},
	},
	"/audit/categorization/2/1": {
		ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
		PATTERN: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Подключение шаблона
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание
				</div>
			),
		},
		PRINT: {
			color: "#DD0BAF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M13.5 5.75H4.5V3.5C4.5 3.2875 4.572 3.10925 4.716 2.96525C4.86 2.82125 5.038 2.7495 5.25 2.75H12.75C12.9625 2.75 13.1408 2.822 13.2848 2.966C13.4288 3.11 13.5005 3.288 13.5 3.5V5.75ZM13.5 9.875C13.7125 9.875 13.8908 9.803 14.0348 9.659C14.1788 9.515 14.2505 9.337 14.25 9.125C14.25 8.9125 14.178 8.73425 14.034 8.59025C13.89 8.44625 13.712 8.3745 13.5 8.375C13.2875 8.375 13.1093 8.447 12.9653 8.591C12.8213 8.735 12.7495 8.913 12.75 9.125C12.75 9.3375 12.822 9.51575 12.966 9.65975C13.11 9.80375 13.288 9.8755 13.5 9.875ZM6 14.75H12V11.75H6V14.75ZM6 16.25C5.5875 16.25 5.23425 16.103 4.94025 15.809C4.64625 15.515 4.4995 15.162 4.5 14.75V13.25H2.25C2.0375 13.25 1.85925 13.178 1.71525 13.034C1.57125 12.89 1.4995 12.712 1.5 12.5V8.75C1.5 8.1125 1.71875 7.578 2.15625 7.1465C2.59375 6.715 3.125 6.4995 3.75 6.5H14.25C14.8875 6.5 15.422 6.71575 15.8535 7.14725C16.285 7.57875 16.5005 8.113 16.5 8.75V12.5C16.5 12.7125 16.428 12.8908 16.284 13.0348C16.14 13.1788 15.962 13.2505 15.75 13.25H13.5V14.75C13.5 15.1625 13.353 15.5158 13.059 15.8098C12.765 16.1038 12.412 16.2505 12 16.25H6Z"
								fill="#DD0BAF"
							/>
						</svg>
					</div>
					Печать
				</div>
			),
		},
	},
	"/audit/categorization/2/2": {
		ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
		INFO_ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление значения в доп. сведения
				</div>
			),
		},
		INFO_EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование значения в доп. сведениях
				</div>
			),
		},
		INFO_DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление значения в доп. сведениях
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание
				</div>
			),
		},
		PRINT: {
			color: "#DD0BAF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M13.5 5.75H4.5V3.5C4.5 3.2875 4.572 3.10925 4.716 2.96525C4.86 2.82125 5.038 2.7495 5.25 2.75H12.75C12.9625 2.75 13.1408 2.822 13.2848 2.966C13.4288 3.11 13.5005 3.288 13.5 3.5V5.75ZM13.5 9.875C13.7125 9.875 13.8908 9.803 14.0348 9.659C14.1788 9.515 14.2505 9.337 14.25 9.125C14.25 8.9125 14.178 8.73425 14.034 8.59025C13.89 8.44625 13.712 8.3745 13.5 8.375C13.2875 8.375 13.1093 8.447 12.9653 8.591C12.8213 8.735 12.7495 8.913 12.75 9.125C12.75 9.3375 12.822 9.51575 12.966 9.65975C13.11 9.80375 13.288 9.8755 13.5 9.875ZM6 14.75H12V11.75H6V14.75ZM6 16.25C5.5875 16.25 5.23425 16.103 4.94025 15.809C4.64625 15.515 4.4995 15.162 4.5 14.75V13.25H2.25C2.0375 13.25 1.85925 13.178 1.71525 13.034C1.57125 12.89 1.4995 12.712 1.5 12.5V8.75C1.5 8.1125 1.71875 7.578 2.15625 7.1465C2.59375 6.715 3.125 6.4995 3.75 6.5H14.25C14.8875 6.5 15.422 6.71575 15.8535 7.14725C16.285 7.57875 16.5005 8.113 16.5 8.75V12.5C16.5 12.7125 16.428 12.8908 16.284 13.0348C16.14 13.1788 15.962 13.2505 15.75 13.25H13.5V14.75C13.5 15.1625 13.353 15.5158 13.059 15.8098C12.765 16.1038 12.412 16.2505 12 16.25H6Z"
								fill="#DD0BAF"
							/>
						</svg>
					</div>
					Печать
				</div>
			),
		},
	},
	"/audit/categorization/3": {
		ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление в перечень
				</div>
			),
		},
		APPEND: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление в дополнение в перечень
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
		LIST: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Формирование перечня/дополнения
				</div>
			),
		},
		DOCUMENT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Загрузка утверждающего документа
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание
				</div>
			),
		},
		PRINT: {
			color: "#DD0BAF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M13.5 5.75H4.5V3.5C4.5 3.2875 4.572 3.10925 4.716 2.96525C4.86 2.82125 5.038 2.7495 5.25 2.75H12.75C12.9625 2.75 13.1408 2.822 13.2848 2.966C13.4288 3.11 13.5005 3.288 13.5 3.5V5.75ZM13.5 9.875C13.7125 9.875 13.8908 9.803 14.0348 9.659C14.1788 9.515 14.2505 9.337 14.25 9.125C14.25 8.9125 14.178 8.73425 14.034 8.59025C13.89 8.44625 13.712 8.3745 13.5 8.375C13.2875 8.375 13.1093 8.447 12.9653 8.591C12.8213 8.735 12.7495 8.913 12.75 9.125C12.75 9.3375 12.822 9.51575 12.966 9.65975C13.11 9.80375 13.288 9.8755 13.5 9.875ZM6 14.75H12V11.75H6V14.75ZM6 16.25C5.5875 16.25 5.23425 16.103 4.94025 15.809C4.64625 15.515 4.4995 15.162 4.5 14.75V13.25H2.25C2.0375 13.25 1.85925 13.178 1.71525 13.034C1.57125 12.89 1.4995 12.712 1.5 12.5V8.75C1.5 8.1125 1.71875 7.578 2.15625 7.1465C2.59375 6.715 3.125 6.4995 3.75 6.5H14.25C14.8875 6.5 15.422 6.71575 15.8535 7.14725C16.285 7.57875 16.5005 8.113 16.5 8.75V12.5C16.5 12.7125 16.428 12.8908 16.284 13.0348C16.14 13.1788 15.962 13.2505 15.75 13.25H13.5V14.75C13.5 15.1625 13.353 15.5158 13.059 15.8098C12.765 16.1038 12.412 16.2505 12 16.25H6Z"
								fill="#DD0BAF"
							/>
						</svg>
					</div>
					Печать
				</div>
			),
		},
	},
	"/audit/categorization/4/1": {
		ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		IMPORT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Импорт файла ФСТЭК
				</div>
			),
		},
		DOCUMENT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Импорт утверждающего документа
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление
				</div>
			),
		},
	},
	"/audit/categorization/4/2": {
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
	},
	"/audit/categorization/5": {
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Редактирование
				</div>
			),
		},
		DOCUMENT: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Загрузка утверждающего документа
				</div>
			),
		},
		DELETE: {
			color: "#DD0B24",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.1875 5H12.9375V3.59375C12.9375 2.97324 12.433 2.46875 11.8125 2.46875H6.1875C5.56699 2.46875 5.0625 2.97324 5.0625 3.59375V5H2.8125C2.50137 5 2.25 5.25137 2.25 5.5625V6.125C2.25 6.20234 2.31328 6.26562 2.39062 6.26562H3.45234L3.88652 15.459C3.91465 16.0584 4.41035 16.5312 5.00977 16.5312H12.9902C13.5914 16.5312 14.0854 16.0602 14.1135 15.459L14.5477 6.26562H15.6094C15.6867 6.26562 15.75 6.20234 15.75 6.125V5.5625C15.75 5.25137 15.4986 5 15.1875 5ZM11.6719 5H6.32812V3.73438H11.6719V5Z"
								fill="#F2485C"
							/>
						</svg>
					</div>
					Удаление документа
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание
				</div>
			),
		},
	},
	"/audit/categorization/6": {
		ADD: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление
				</div>
			),
		},
		BUNDLE: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Формирование партии
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание партии
				</div>
			),
		},
	},
	"/audit/categorization/7": {
		ID: {
			color: "#00528C",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect x="8.25" y="3.5" width="1.5" height="12" fill="#005B9B" />
							<rect x="15" y="8.75" width="1.5" height="12" transform="rotate(90 15 8.75)" fill="#005B9B" />
						</svg>
					</div>
					Добавление реестрового номера
				</div>
			),
		},
		LETTER: {
			color: "#35A440",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.405 4.4225L14.3625 3.1625C14.16 2.9075 13.8525 2.75 13.5 2.75H4.5C4.1475 2.75 3.84 2.9075 3.63 3.1625L2.595 4.4225C2.3775 4.6775 2.25 5.015 2.25 5.375V14.75C2.25 15.575 2.925 16.25 3.75 16.25H14.25C15.075 16.25 15.75 15.575 15.75 14.75V5.375C15.75 5.015 15.6225 4.6775 15.405 4.4225ZM9 13.625L4.875 9.5H7.5V8H10.5V9.5H13.125L9 13.625ZM3.84 4.25L4.4475 3.5H13.4475L14.1525 4.25H3.84Z"
								fill="#35A440"
							/>
						</svg>
					</div>
					Загрузка ответного письма
				</div>
			),
		},
		EDIT: {
			color: "#EA8F06",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.4688 15.1953H2.53125C2.22012 15.1953 1.96875 15.4467 1.96875 15.7578V16.3906C1.96875 16.468 2.03203 16.5312 2.10938 16.5312H15.8906C15.968 16.5312 16.0312 16.468 16.0312 16.3906V15.7578C16.0312 15.4467 15.7799 15.1953 15.4688 15.1953ZM4.52988 13.7188C4.56504 13.7188 4.6002 13.7152 4.63535 13.71L7.59199 13.1914C7.62715 13.1844 7.66055 13.1686 7.68516 13.1422L15.1365 5.69082C15.1528 5.67456 15.1657 5.65524 15.1746 5.63398C15.1834 5.61271 15.1879 5.58992 15.1879 5.56689C15.1879 5.54387 15.1834 5.52108 15.1746 5.49981C15.1657 5.47855 15.1528 5.45923 15.1365 5.44297L12.215 2.51973C12.1816 2.48633 12.1377 2.46875 12.0902 2.46875C12.0428 2.46875 11.9988 2.48633 11.9654 2.51973L4.51406 9.97109C4.4877 9.99746 4.47187 10.0291 4.46484 10.0643L3.94629 13.0209C3.92919 13.1151 3.9353 13.212 3.96409 13.3033C3.99288 13.3945 4.04349 13.4774 4.11152 13.5447C4.22754 13.6572 4.37344 13.7188 4.52988 13.7188Z"
								fill="#FFA51F"
							/>
						</svg>
					</div>
					Обновление данных
				</div>
			),
		},
		READ: {
			color: "black",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="24" height="18" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
								fill="#181818"
							/>
							<path
								d="M23.0091 11.1844C21.7687 9.26625 20.1595 7.63688 18.3558 6.47203C16.3603 5.18203 14.1572 4.5 11.985 4.5C9.99187 4.5 8.03203 5.06953 6.15984 6.19266C4.25062 7.33781 2.52093 9.01078 1.01859 11.1647C0.84899 11.4081 0.755584 11.6965 0.750243 11.9931C0.744901 12.2897 0.827865 12.5813 0.988591 12.8306C2.22656 14.768 3.81984 16.3997 5.59547 17.5486C7.59468 18.8438 9.74625 19.5 11.985 19.5C14.1745 19.5 16.3823 18.8236 18.3694 17.5444C20.1722 16.3833 21.7781 14.7478 23.0137 12.8137C23.1689 12.5702 23.251 12.2872 23.2502 11.9984C23.2493 11.7096 23.1656 11.4271 23.0091 11.1844ZM12.0009 16.5C11.1109 16.5 10.2409 16.2361 9.50087 15.7416C8.76085 15.2471 8.18407 14.5443 7.84348 13.7221C7.50288 12.8998 7.41377 11.995 7.5874 11.1221C7.76103 10.2492 8.18962 9.44736 8.81895 8.81802C9.44829 8.18868 10.2501 7.7601 11.123 7.58647C11.9959 7.41283 12.9007 7.50195 13.723 7.84254C14.5453 8.18314 15.2481 8.75991 15.7425 9.49993C16.237 10.24 16.5009 11.11 16.5009 12C16.4996 13.1931 16.025 14.3369 15.1814 15.1805C14.3378 16.0241 13.194 16.4986 12.0009 16.5Z"
								fill="#181818"
							/>
						</svg>
					</div>
					Просмотр данных объекта
				</div>
			),
		},
		DOWNLOAD: {
			color: "#4B06DF",
			text: (
				<div className={sass.badge}>
					<div>
						<svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M9 2C4.8675 2 1.5 5.3675 1.5 9.5C1.5 13.6325 4.8675 17 9 17C13.1325 17 16.5 13.6325 16.5 9.5C16.5 5.3675 13.1325 2 9 2ZM8.25 8V5H9.75V8H12L9 11L6 8H8.25ZM12.75 13.25H5.25V11.75H12.75V13.25Z"
								fill="#4C1FFF"
							/>
						</svg>
					</div>
					Скачивание прикрепленного документа
				</div>
			),
		},
	},
};
